/**
 * @file   src\mobile\components\ReceiveIntroduction\AgentProfileInfoModal.js
 * @brief  This file is responsible for showing agent profile in receive introduction section.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { getUserDetails } from "../../../services/userprofileService";

const AgentProfileInfoModal = (props) => {
  const { isTitleShow, show, onHide } = props;

  const [userDetails, setUserDetails] = useState([]);

  useEffect(() => {
    if (props?.userId) {
      getUserDetailsById();
    }
  }, [props?.userId]);

  /**
   * To get user details
   */
  const getUserDetailsById = async () => {
    await getUserDetails({ id: props?.userId })
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        if (response.errorCode === 0 && responseResult) {
          setUserDetails(responseResult && responseResult[0]);
        } else {
          console.log("Something went wrong");
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modalPopupstyle delete-popup profile-modal"
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="text-center">
        <h3>Agent Profile!</h3>
        {isTitleShow && (
          <p className="f-size-16">
            A licensed real-estate agent is representing this property.
          </p>
        )}
        <div className="agent-profile-information text-start">
          <div className="sepLine">
            <div className="profile-details">
              <div className="d-flex align-items-center">
                {userDetails?.Img ? (
                  <span className="profile-pic">
                    <img src={userDetails?.Img ?? noImage} alt="" />
                  </span>
                ) : (
                  <div className="profile-placeholder-wrap profile-bg-orange">
                    {(userDetails?.FirstName + " " + userDetails?.LastName)
                      .replace(/-/g, "")
                      .match(/\b(\w)/g)}
                  </div>
                )}
                <div className="profile-name">
                  <div className="title d-flex align-items-center">
                    <h2>
                      {" "}
                      {userDetails?.FirstName + " " + userDetails?.LastName}
                    </h2>
                    {userDetails?.PlanName === "Pro Member" && (
                      <span className="pro-blue-badge ms-2">PRO</span>
                    )}
                  </div>
                  {userDetails?.Company && (
                    <p className="m-0">Agent @ {userDetails?.Company}</p>
                  )}
                </div>
              </div>
            </div>
            {userDetails?.Bio && (
              <div className="bio">
                <span className="smallTitle">Bio</span>
                <p> {userDetails?.Bio}</p>
              </div>
            )}
          </div>
          <div className="agent-personal-info d-flex flex-column">
            <div className="info-group d-flex justify-content-between">
              <p className="title m-0">Phone number</p>
              <p className="m-0">{userDetails?.Phone}</p>
            </div>
            <div className="info-group d-flex justify-content-between">
              <p className="title m-0">Work location</p>
              <p className="m-0">{userDetails?.Location}</p>
            </div>
            <div className="info-group d-flex justify-content-between">
              <p className="title m-0">Company</p>
              <p className="m-0 text-right">{userDetails?.Company}</p>
            </div>
            <div className="info-group d-flex justify-content-between">
              <p className="title m-0">License number</p>
              <p className="m-0">{userDetails?.LicenseNo}</p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default AgentProfileInfoModal;
